module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 mt-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.files,
      "pagination": _vm.pagination,
      "total-items": _vm.totalFiles,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.fileName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.approved))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "white--text",
          attrs: {
            "color": "#1f5b41"
          },
          on: {
            "click": function($event) {
              return _vm.approveFile(props.item)
            }
          }
        }, [_vm._v("Approve")])], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.rejectFile(props.item)
            }
          }
        }, [_vm._v("Reject")])], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.viewFile(props.item)
            }
          }
        }, [_vm._v("View")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "900px"
    },
    model: {
      value: (_vm.viewRecordsDialog),
      callback: function($$v) {
        _vm.viewRecordsDialog = $$v
      },
      expression: "viewRecordsDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1 mt-3",
    attrs: {
      "headers": _vm.viewFileheaders,
      "items": _vm.records
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.merchantId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.terminalId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstEmail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.secondEmail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.orgName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstCustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstCustomerLastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.secondCustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.secondCustomerLastName))])]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.viewRecordsDialog = false
      }
    }
  }, [_vm._v("Cancel ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f5cd45c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/merchant/ApproveBulkUpload.vue
// module id = 1062
// module chunks = 2